import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { Box, Typography } from '@material-ui/core';
import useAsync from 'react-use/lib/useAsync';
import { CustomViewRegister } from '../CustomView';
import { GenericField } from '../DisplayValue';
import { CustomViewGridElement } from './utility';

CustomViewRegister.register({
  id: 'string',
  function: function StringView(props: Record<string, any>) {
    const maxLines = props.maxLines;
    const showMoreButton = props.showMoreButton ?? true;

    switch (props.mode) {
      case 'table':
        return (
          <GenericField
            type="string"
            {...props}
            label={undefined}
            // for table fields we always want to truncate at one line
            maxLines={undefined}
            showTooltip
          />
        );
      case 'linear':
        return <GenericField type="string" maxLines={maxLines} {...props} />;
      default:
    }
    return (
      <CustomViewGridElement colSpan={props.colSpan}>
        <GenericField
          maxLines={maxLines}
          gridItem={false}
          {...props}
          showMoreButton={showMoreButton}
        />
      </CustomViewGridElement>
    );
  },
});

CustomViewRegister.register({
  id: 'profile',
  function: function StringView(props: Record<string, any>) {
    const catalogApi = useApi(catalogApiRef);
    const maxLines = props.maxLines;
    const showMoreButton = props.showMoreButton ?? true;
    let value = props.value;
    const { value: entity } = useAsync(() => catalogApi.getEntityByRef(value));
    if (entity) {
      if (!!entity.spec && !!entity.spec.profile) {
        const profile = entity.spec.profile as { [key: string]: any };
        if (!!profile.displayName && !!profile.email) {
          value = `${profile.displayName} <${profile.email}>`;
        }
      }
    }
    switch (props.mode) {
      case 'table':
        return (
          <GenericField
            type="string"
            maxLines={maxLines}
            {...props}
            value={value}
            label={undefined}
          />
        );
      case 'linear':
        return (
          <GenericField
            type="string"
            maxLines={maxLines}
            {...props}
            value={value}
          />
        );
      default:
    }
    return (
      <CustomViewGridElement colSpan={props.colSpan}>
        <GenericField
          maxLines={maxLines}
          showMoreButton={showMoreButton}
          gridItem={false}
          {...props}
          value={value}
          contentProps={{ style: { wordBreak: 'break-all' } }}
        />
      </CustomViewGridElement>
    );
  },
});

CustomViewRegister.register({
  id: 'date',
  function: function DateView(props: Record<string, any>) {
    const value = props.value;
    switch (props.mode) {
      case 'table':
      case 'linear':
        return (
          <GenericField
            type="date"
            gridItem={false}
            dateFormat={props.dateFormat}
            icon={props.icon}
            value={value}
            showTooltip
          />
        );
      default:
    }
    return (
      <CustomViewGridElement colSpan={props.colSpan}>
        <GenericField
          type="date"
          gridItem={false}
          value={value}
          dateFormat={props.dateFormat}
          label={props.label}
          icon={props.icon}
        />
      </CustomViewGridElement>
    );
  },
});

CustomViewRegister.register({
  id: 'title',
  function: function StringView(props: Record<string, any>) {
    return (
      <Typography variant="h6" style={{ paddingLeft: 8 }}>
        {props.value}
      </Typography>
    );
  },
});

CustomViewRegister.register({
  id: 'image',
  function: function ImageView(props: Record<string, any>) {
    if ((props.value || '') === '') return <></>;
    return (
      <Box display="flex" justifyContent="center">
        <img
          alt={props.title || ''}
          src={props.value}
          style={{ maxHeight: props.maxHeight ?? 250 }}
        />
      </Box>
    );
  },
});
